"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatusBadge = TaskStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../table");
var STATUS_COLORS = {
    OPEN: "navy",
    COMPLETE: "green-soft",
    OVERDUE: "red-solid",
};
function TaskStatusBadge(props) {
    var status = props.status;
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: STATUS_COLORS[status], children: status });
}
